import { Modal as AntdModal, type ModalProps as AntdModalProps, type ModalFuncProps } from 'antd';

export type ModalProps = AntdModalProps;

const DEFAULTS = {
  destroyOnHidden: true,
  footer: null,
  mask: { closable: false },
} satisfies Partial<AntdModalProps>;

export const Modal = ({ mask, ...props }: ModalProps) => (
  <AntdModal
    {...DEFAULTS}
    {...props}
    mask={typeof mask === 'object' ? { ...DEFAULTS.mask, ...mask } : mask ?? DEFAULTS.mask}
  />
);

export const confirm = (props: ModalFuncProps) =>
  AntdModal.confirm({
    icon: null,
    okText: 'Confirm',
    ...props,
  });
